var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10349_28179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 12.5003C7.23866 12.5003 5.00008 10.2617 5.00008 7.50033V2.8707C5.00008 2.52582 5.00008 2.35339 5.05034 2.21531C5.13459 1.98384 5.31693 1.8015 5.5484 1.71725C5.68648 1.66699 5.85891 1.66699 6.20379 1.66699H13.7964C14.1413 1.66699 14.3137 1.66699 14.4518 1.71725C14.6832 1.8015 14.8656 1.98384 14.9498 2.21531C15.0001 2.35339 15.0001 2.52582 15.0001 2.8707V7.50033C15.0001 10.2617 12.7615 12.5003 10.0001 12.5003ZM10.0001 12.5003V15.0003M15.0001 3.33366H17.0834C17.4717 3.33366 17.6658 3.33366 17.819 3.39709C18.0232 3.48167 18.1854 3.6439 18.27 3.84809C18.3334 4.00123 18.3334 4.19537 18.3334 4.58366V5.00033C18.3334 5.7753 18.3334 6.16279 18.2482 6.48071C18.0171 7.34344 17.3432 8.01731 16.4805 8.24847C16.1625 8.33366 15.7751 8.33366 15.0001 8.33366M5.00008 3.33366H2.91675C2.52846 3.33366 2.33432 3.33366 2.18118 3.39709C1.97699 3.48167 1.81476 3.6439 1.73018 3.84809C1.66675 4.00123 1.66675 4.19537 1.66675 4.58366V5.00033C1.66675 5.7753 1.66675 6.16279 1.75193 6.48071C1.9831 7.34344 2.65697 8.01731 3.5197 8.24847C3.83762 8.33366 4.22511 8.33366 5.00008 8.33366M6.20379 18.3337H13.7964C14.0009 18.3337 14.1667 18.1678 14.1667 17.9633C14.1667 16.3269 12.8402 15.0003 11.2038 15.0003H8.79638C7.15998 15.0003 5.83341 16.3269 5.83341 17.9633C5.83341 18.1678 5.99924 18.3337 6.20379 18.3337Z",
    stroke: "#505050",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10349_28179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContest);
export default __webpack_public_path__ + "static/media/contest.38659750a953c9fb9b556e1de6d16bb4.svg";
export { ForwardRef as ReactComponent };